import { Client, Controller, mapUrl } from "@/repository";

export interface AicLockStatusResponse {
	isLocked: boolean;
	lockedAt?: string;
}

export const fetchAicLockStatus = (): Promise<AicLockStatusResponse> =>
	Client.instance.get<AicLockStatusResponse>(
		mapUrl(Controller.AicLocking, "status")
	);
